import { useEffect, useState } from "react";
import axiosClient from "../../../../utils/api/axiosClient";
import { getToken } from "../../../../utils/functions";
import { ICaste } from "../cast";
import { IReligion } from "../religion";
import FormModel from "./models/FormModel";

export interface ISubCaste {
  id: number;
  name: string;
  casteId: number;
  religionId: number;
}

export const initialFormData: ISubCaste = {
  id: 0,
  name: "",
  casteId: 0,
  religionId: 0,
};

function City() {
  const [subCastes, setSubCastes] = useState<ISubCaste[]>([]);
  const [castes, setCastes] = useState<ICaste[]>([]);
  const [religions, setReligions] = useState<IReligion[]>([]);
  const [initial, setInitial] = useState<ISubCaste>(initialFormData);

  useEffect(() => {
    const headers = { Authorization: getToken() };
    axiosClient.get("v1/sub-castes", { headers }).then((res) => {
      if (res.status === 200) setSubCastes(res.data);
    });
    axiosClient.get("v1/castes", { headers }).then((res) => {
      if (res.status === 200) setCastes(res.data);
    });
    axiosClient.get("v1/religions", { headers }).then((res) => {
      if (res.status === 200) setReligions(res.data);
    });
  }, []);

  const handleDelete = (id: number) => {
    const headers = { Authorization: getToken() };
    axiosClient.delete("v1/sub-castes/" + id, { headers }).then((res) => {
      if (res.status === 200) setSubCastes(res.data);
    });
  };

  const handleEdit = (subCaste: ISubCaste) => {
    setInitial(subCaste);
    setModalShow(true);
  };

  const handleCreate = () => {
    setInitial(initialFormData);
    setModalShow(true);
  };

  const [modalShow, setModalShow] = useState(false);

  return (
    <div className="app-content pt-3 p-md-3 p-lg-4">
      <div className="container-xl">
        <h1 className="app-page-title">Sub Castes</h1>
        <div className="row">
          <div className=" col-lg-12 ">
            <div className="card">
              <div className="card-header gutters-5">
                <h5 className="mb-md-0 h6">
                  All Sub Castes
                  <i
                    onClick={handleCreate}
                    className="fa fa-plus btn btn-sm pull-right"
                  ></i>
                </h5>
              </div>
              <div className="card-body">
                <table className="table aiz-table mb-0 footable footable-1 breakpoint-lg">
                  <thead>
                    <tr className="footable-header">
                      <th style={{ display: "table-cell" }}>#</th>
                      <th style={{ display: "table-cell" }}>Sub Caste Name</th>
                      <th style={{ display: "table-cell" }}>Caste</th>
                      <th style={{ display: "table-cell" }}>Reigion</th>
                      <th
                        className="text-right"
                        style={{ display: "table-cell", width: "20%" }}
                      >
                        Options
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {subCastes.length ? (
                      subCastes.map((subCaste, index) => {
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{subCaste.name}</td>
                            <td>
                              {
                                castes.find((c) => c.id === subCaste.casteId)
                                  ?.name
                              }
                            </td>
                            <td>
                              {
                                religions.find(
                                  (r) => r.id === subCaste.religionId
                                )?.name
                              }
                            </td>
                            <td>
                              <i
                                className="fa fa-pencil btn btn-sm"
                                onClick={() => handleEdit(subCaste)}
                              ></i>
                              <i
                                className="fa fa-trash btn btn-sm"
                                onClick={() => handleDelete(subCaste.id)}
                              ></i>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="footable-empty text-center">
                        <td colSpan={5}>Nothing Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="aiz-pagination"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FormModel
        {...{
          setSubCastes,
          setCastes,
          initial,
          setInitial,
          modalShow,
          setModalShow,
          religions,
          castes,
        }}
      />
    </div>
  );
}

export default City;
